import { PageContainer, Spinner } from "@shapr3d/frontend-lib";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";

import { OverlayProvider } from "../../components/Headers/components/ShareModal/components/MenuPortal";
import { ViewLinkList } from "../../components/ViewLinkList/ViewLinkList";
import { useGuardSyncOffTeams } from "../../hooks/useGuardSyncOffTeams";
import { useProjectViewLinkList } from "../../hooks/useProjectViewLink";

import style from "./ViewLinkListPage.module.css";

function ViewLinkListPageComponent() {
  const { teamID } = useParams();
  useGuardSyncOffTeams({ enabled: true });

  const { data, isLoading, fetchNextPage, isFetchingNextPage, hasNextPage } =
    useProjectViewLinkList({
      teamId: teamID,
      latestByProject: true,
    });

  if (isLoading) {
    return (
      <div className={style.pageContainer}>
        <Spinner />
      </div>
    );
  }

  return (
    <OverlayProvider>
      <PageContainer title="Published versions">
        <ViewLinkList
          viewLinks={data?.projectViewLinks ?? []}
          users={data?.users ?? []}
          telemetryLocation="review_links"
          isUnpublishHidden
          fetchNextPage={fetchNextPage}
          isFetchingNextPage={isFetchingNextPage}
          hasNextPage={hasNextPage}
        />
      </PageContainer>
    </OverlayProvider>
  );
}

export default function ViewLinkListPage() {
  return (
    <>
      <Helmet>
        <title>Shapr3D - Dashboard</title>
        <meta
          name="description"
          content="Review designs together. View models and add comments directly to your 3D design."
        />
      </Helmet>
      <ViewLinkListPageComponent />
    </>
  );
}
